export default "__VITE_ASSET__CXU0RUnN__"